import React, { useState, useEffect, useRef, useCallback } from "react";
import styled from "styled-components";
import { Divider, message } from "antd";
import MainWrapper from "../components/MainWrapper";
import TransactionInfoCard from "../components/TransactionInfoCard";
import ThaiQrLogo from "../assets/thaiQr.png";
import WalletTrue from "../assets/walletTrue.png";
import PendingImage from "../assets/waiting.png";
import Prompt from "../assets/prompt.png";
import expiredQr from "../assets/expiredQr.png";
import { useSelector, useDispatch } from "react-redux";
import getQrManualCheck from "../redux/actions/getQrManualCheck";
import SuccessMessage from "../components/SuccessMessage";
import { language } from "../utils/language";
import { toLocaleStringFormate } from "../helpingFunctions";
import { useNavigate, useParams } from "react-router-dom";
import { QR_MANUAL_CHECK } from "../redux/constants/transaction";
const CardWrapper = styled.div`
  // height: 750px;
  width: 350px;
  z-index: 999 !important;
  background-color: white;
  border-radius: 10px;

  @media (min-width: 280px) and (max-width: 380px) {
    width: 290px !important;
  }

  .card_header {
    background-color: #133666;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: start;
    border-radius: 10px 10px 0 0;
  }
  .card_footer hr {
    background-color: black;
  }
  .baht_amount {
    // font-size: 18px;
    font-weight: bold;
  }
  .amount_sec {
    font-size: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .timer_sec {
    color: red;
    text-align: center;
  }
  .timer_sec span {
    font-size: 16px;
    font-weight: 600;
  }
  .success_message {
    font-size: 18px;
    color: green;
    font-weight: bold;
  }
`;

const QrCardInfo = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();
  const [time, setTime] = useState({
    minutes: 15,
    seconds: 0,
  });

  const [confirmQrManualData, setConfirmQrManualData] = useState(null);
  const verifyManualTransactionState = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { data: verifyManualData } = verifyManualTransactionState;

  const warningModalState = useSelector((state) => state.warningModalReducer);
  const { modalShow, data: modalShowData } = warningModalState;

  const { data: qrManualCheckData } = useSelector(
    (state) => state.getQrManualCheckReducer
  );
  const { data } = useSelector((state) => state.postQrInitManualReducer);
  const { link } = useSelector((state) => state.getRedictionalUrl); //Get rediction link from reducer
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const [expiredQrImage, setExpiredQrIamge] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [timeLeft, setTimeLeft] = useState(15 * 60 * 1000); // 15 minutes in milliseconds

  // Convert time left to minutes and seconds
  const minutes = Math.floor(timeLeft / (1000 * 60));
  const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

  useEffect(() => {
    const userAgent = navigator.userAgent;
    const mobilePatterns = [
      "Android",
      "webOS",
      "iPhone",
      "iPad",
      "iPod",
      "BlackBerry",
      "Windows Phone",
    ];

    const detectedMobile = mobilePatterns.some((pattern) =>
      userAgent.includes(pattern)
    );
    setIsMobile(detectedMobile);
  }, []); // Empty dependency array ensures this effect runs only once on component mount

  const redirectLink = link || verifyManualData?.siteUrl;

  useEffect(() => {
    dispatch(
      getQrManualCheck(verifyManualData.trxRef, verifyManualData.merchantId)
    );
  }, [])

  useEffect(() => {
    // Set the end time
    const endTime = new Date().getTime() + 15 * 60 * 1000;

    // Update the time left every second
    const timerId = setInterval(() => {
      const currentTime = new Date().getTime();
      const difference = endTime - currentTime;

      if (difference <= 0) {
        clearInterval(timerId);
        setTimeLeft(0); // Set to 0 when the timer finishes
        setExpiredQrIamge(true);
      } else {
        setTimeLeft(difference); // Update the time left
      }
    }, 1000);

    // Clean up the timer on component unmount
    return () => clearInterval(timerId);
  }, []);

  const dispatchQrManualCheck = useCallback(() => {
    dispatch(
      getQrManualCheck(verifyManualData.trxRef, verifyManualData.merchantId)
    );
  }, []);

  // useEffect(() => {
  //   console.log('api call in use callback');

  //   if (timeLeft > 0 && qrManualCheckData.status == "00_Initiated") {
  //     dispatchQrManualCheck();
  //   }
  // }, [timeLeft, dispatchQrManualCheck, qrManualCheckData]);


  useEffect(() => {
    let timerId
    // Set the end time
    const endTime = new Date().getTime() + 15 * 60 * 1000;
    if (qrManualCheckData.status == "00_Initiated") {
      // Update the time left every second
      timerId = setInterval(() => {
        const currentTime = new Date().getTime();
        const difference = endTime - currentTime;

        if (difference <= 0) {
          clearInterval(timerId);
        } else {
          dispatchQrManualCheck();
        }
      }, 3000);
    }

    // Clean up the timer on component unmount
    return () => clearInterval(timerId);
  }, [qrManualCheckData]);

  useEffect(() => {
    if (
      qrManualCheckData.status == "02_Paid" ||
      qrManualCheckData.status == "03_Rejected" ||
      qrManualCheckData.status == "01_Pending"
    ) {
      setConfirmQrManualData(qrManualCheckData);
      if (qrManualCheckData.status == "03_Rejected" && timeLeft === 0) {
        message.error("Your QR Code has been expired", 5);
        setExpiredQrIamge(true);

        if (redirectLink) {
          window.open(redirectLink, "_blank");
          dispatch({
            type: QR_MANUAL_CHECK.SUCCESS,
            payLoad: "",
          });
        }
      }
    }
  }, [qrManualCheckData, timeLeft]);

  useEffect(() => {
    if (data === "") {
      navigate(`/${params.id}`);
    }
  }, [data]);

  useEffect(() => {
    if (
      qrManualCheckData &&
      qrManualCheckData.status === "02_Paid" &&
      !isMobile
    ) {
      setTimeout(() => {
        if (redirectLink) {
          window.open(`${redirectLink}`, "_blank");
        } else if (!window?.location?.search) {
          window.open(`${verifyManualData?.siteUrl}`, "_blank");
        } else if (verifyManualData?.redirectUrl) {
          window.open(`${verifyManualData?.redirectUrl}`, "_blank");
        } else {
          window.open(`${verifyManualData?.siteUrl}`, "_blank");
        }
      }, 100);
    } else if (
      qrManualCheckData &&
      qrManualCheckData.status === "02_Paid" &&
      isMobile
    ) {
      setTimeout(() => {
        if (redirectLink) {
          window.location.href = redirectLink;
        } else if (!window?.location?.search) {
          window.location.href = verifyManualData?.siteUrl;
        } else if (verifyManualData?.redirectUrl) {
          window.location.href = verifyManualData?.redirectUrl;
        } else {
          window.location.href = verifyManualData?.siteUrl;
        }
      }, 100);
    }
  }, [qrManualCheckData]);

  return (
    <MainWrapper>
      {confirmQrManualData?.status === "01_Pending" || confirmQrManualData?.status === "02_Paid" ?
        null
        :
        <>
          <p
            className="mt-5 text-center"
            style={{ color: "#fff", fontSize: 16, width: "350px" }}
          >
            {params.type === "truemoney-payment-method"
              ? language[lang].qrCodeInfo.SQR_TO_PAY_TRUE_MONEY
              : language[lang].qrCodeInfo.SQR_TO_PAY}
          </p>
          {params.type === "auto-payment-method" &&
            <p
              className="mb-4 mt-2 text-center"
              style={{ color: "#fff", fontSize: 16, width: "350px" }}
            >
              บัญชีที่สแกนต้องเป็นบัญชีที่ผูกไว้เท่านั้น
              หากบัญชีไม่ตรงยอดเงินไม่ปรับ ออโต้
            </p>}
        </>
      }
      <CardWrapper>
        {confirmQrManualData?.status === "01_Pending" &&
          <span>
            <p
              className="m-3 mb-0 text-center"
              style={{ color: "#000", fontSize: 16 }}
            >
              {language[lang].qrCodeInfo.PENDING_MESSAGE.split('-')[0]}
            </p>
            <p
              className="m-3 mb-0 mt-0 text-center"
              style={{ color: "#000", fontSize: 16 }}
            >
              {language[lang].qrCodeInfo.PENDING_MESSAGE.split('-')[1]}
            </p>
          </span>
        }

        <div className="qr_code pt-3 px-3" style={{ position: "relative" }}>
          {confirmQrManualData?.status === "02_Paid" ? (
            <SuccessMessage />
          ) :
            confirmQrManualData?.status === "01_Pending" ?
              <div className="d-flex flex-column justify-content-center align-items-center">
                <img src={PendingImage} width="50%" height="50%" />
              </div> :
              (expiredQrImage === true || data.qrImage === undefined) ? (
                <img src={expiredQr} width="100%" height="100%" />
              ) : (
                <div className="d-flex w-100">
                  {data?.bgn === "64fc05244701c66c809dc558" ||
                    data?.bgn === "6508870f9402b87cbdcac143" ? (
                    <p
                      style={{
                        top: 10,
                        left: 0,
                        position: "absolute",
                        fontSize: 42,
                        color: "orange",
                        textAlign: "center",
                        width: 290,
                        marginBottom: 0,
                        opacity: 0.6,
                      }}
                    >
                      {/* {params.type == "truemoney-payment-method"
                  ?  */}
                      QR Code สำหรับโบรกเกอร์ออนไลน์เท่านั้น
                      {/* : null} */}
                    </p>
                  ) : null}
                  <img
                    src={"data:image/jpeg;base64," + data.qrImage}
                    width="100%"
                  />
                </div>
              )}
        </div>
        <div className="card_footer px-3">
          <div className="d-flex justify-content-center">
            {params.type == "truemoney-payment-method" ? (
              <img src={WalletTrue} height="80px" />
            ) : (
              <div className="w-100 d-flex justify-content-between align-items-center">
                <img src={Prompt} width="45%" height="60px" />
                <img src={ThaiQrLogo} width="45%" height={"50px"} />
              </div>
            )}
          </div>
          <hr className="mt-1 mb-1" />
          <div className="amount_sec">
            <p className="mt-2 mb-0">
              {language[lang].qrCodeInfo.REF_NO}: {data.transRef3}
            </p>
            <h3 className="baht_amount">
              ฿{toLocaleStringFormate(modalShowData?.amount)}
            </h3>

            {confirmQrManualData?.status == "02_Paid" ? (
              <div className="success_message">
                <p className="mb-0 text-center">ได้รับการชำระเงินแล้ว</p>
                <p
                  className="mb-0 text-center"
                  style={{ color: "#000", fontSize: 12 }}
                >
                  กลับสู่หน้าหลักอัติโนมัติ เมื่อการชําระเงินเสร็จสิ้น
                </p>
                <p
                  className="text-center"
                  style={{ color: "#000", fontSize: 12 }}
                >
                  หากไม่สามารถกลับสู่หน้าหลักได้
                  <a
                    target={"_blank"}
                    href={redirectLink}
                    className="fw-bold"
                    style={{ fontSize: 16, cursor: "pointer" }} rel="noreferrer"
                  >
                    โปรดคลิก
                  </a>
                </p>
              </div>
            ) : (
              <div className="timer_sec">
                  {confirmQrManualData?.status === "01_Pending" ? null :
                    <span>
                      <p className="mb-0 ">
                        {language[lang].qrCodeInfo.QR_CODE_EXPIRE}
                      </p>
                      <span>
                        {minutes < 10 ? `0${minutes}` : minutes} :{" "}
                        {seconds < 10 ? `0${seconds}` : seconds}
                      </span>
                      <p className="">
                        {language[lang].qrCodeInfo.REFRESH_PAGE_TEXT}
                      </p>
                    </span>
                  }
                <p
                  className="mb-0 text-center"
                  style={{ color: "#000", fontSize: 12 }}
                >
                  {language[lang].qrCodeInfo.REDIRECT_TEXT}
                </p>
                <p
                  className="text-center"
                  style={{ color: "#000", fontSize: 12 }}
                >
                  {language[lang].qrCodeInfo.REDIRECT_TEXT2}{" "}
                  <a
                    target={"_blank"}
                    href={redirectLink}
                    className="fw-bold"
                    style={{ fontSize: 12, cursor: "pointer" }} rel="noreferrer"
                  >
                    {language[lang].qrCodeInfo.REDIRECT_LINK_TEXT}
                  </a>
                </p>
              </div>
            )}
          </div>
        </div>
      </CardWrapper>
    </MainWrapper>
  );
};

export default QrCardInfo;
